'use client'

import { Icon } from 'shared/iconpack'
import { IconNames } from 'shared/iconpack/model/types'
import { clsx } from 'shared/libs/style-merge'

import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

import styles from './IconButton.module.scss'

export interface IconButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  iconName: IconNames
  iconSize?: 'small' | 'medium' | 'large'
  iconColor: string
  buttonType?: 'squired' | 'rounded'
  buttonColor?: 'primary' | 'secondary' | 'extra'
}

const sizes = {
  small: 20,
  medium: 20,
  large: 24,
}

const sizesStyle = {
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
}

const buttonTypeStyle = {
  squired: styles.squired,
  rounded: styles.rounded,
}

const buttonColorStyle = {
  primary: styles.primary,
  secondary: styles.secondary,
  extra: styles.extra,
}

export function IconButton({
  type = 'button',
  className,
  disabled,
  iconName,
  iconSize = 'medium',
  iconColor,
  buttonType = 'rounded',
  buttonColor = 'primary',
  ...props
}: IconButtonProps) {
  return (
    <button
      className={clsx(
        styles.iconButton,
        sizesStyle[iconSize],
        buttonTypeStyle[buttonType],
        buttonColorStyle[buttonColor],
        className,
      )}
      type={type}
      disabled={disabled}
      {...props}
    >
      <Icon name={iconName} size={sizes[iconSize]} color={iconColor} />
    </button>
  )
}
